import {
  Button,
  Divider,
  Stack,
} from '@mui/material';
import React from 'react';
import Icon from './Icon';

function PickupDeliveryInput({
  hasDelivery,
  pickupText = 'Pickup',
  deliveryText = 'Delivery',
  borderRadius,
  size = 'medium',
  disabled,
  onChange, ...props
}) {
  return (
    <Stack
      divider={<Divider />}
      direction="row"
      sx={{ backgroundColor: 'grey.100', borderRadius: 2 }}
      gap={size === 'small' ? 0 : 0.75}
      {...props}
    >
      <Button
        startIcon={<Icon name="motor-outlined" />}
        variant={hasDelivery ? 'primary' : 'secondary'}
        size={size}
        fullWidth
        onClick={() => onChange(true)}
        sx={theme => ({
          borderRadius,
          fontSize: size === 'small' ? 12 : undefined,
          '&:disabled': {
            backgroundColor: hasDelivery ? theme.palette.text.secondary : theme.palette.background.elevation1,
            color: hasDelivery ? theme.palette.text.white : theme.palette.text.disabled,
          },
        })}
        loading={hasDelivery}
        disabled={disabled}
        endIcon={hasDelivery && <Icon name="checkmark" />}
      >
        {deliveryText}
      </Button>
      <Button
        startIcon={<Icon name="walk-filled" />}
        variant={!hasDelivery ? 'primary' : 'secondary'}
        size={size}
        fullWidth
        onClick={() => onChange(false)}
        sx={theme => ({
          borderRadius,
          fontSize: size === 'small' ? 12 : undefined,
          '&:disabled': {
            backgroundColor: !hasDelivery ? theme.palette.text.secondary : theme.palette.background.elevation1,
            color: !hasDelivery ? theme.palette.text.white : theme.palette.text.disabled,
          },
        })}
        loading={!hasDelivery}
        disabled={disabled}
        endIcon={!hasDelivery && <Icon name="checkmark" />}
      >
        {pickupText}
      </Button>
    </Stack>
  );
}

export default PickupDeliveryInput;
